module.exports = __webpack_public_path__ + "img/package-slide-3.e0a67e23.png";